export var graphs = [
    {
        nodes:[
            {
                id: "n1",
                textId: "t1",
                cx: 50,
                cy: 50,
                text: 1
            },
            {
                id: "n2",
                textId: "t2",
                cx: 200,
                cy: 200,
                text: 2
            },
            {
                id: "n3",
                textId: "t3",
                cx: 100,
                cy: 400,
                text: 3
            },
            {
                id: "n4",
                textId: "t4",
                cx: 400,
                cy: 400,
                text: 4
            },
            {
                id: "n5",
                textId: "t5",
                cx: 400,
                cy: 100,
                text: 5
            },
            {
                id: "n6",
                textId: "t5",
                cx: 300,
                cy: 300,
                text: 6
            }
        ],
        edges:[
            {
                id: "1to2",
                x1: 50,
                y1: 50,
                x2: 200,
                y2: 200
            },
            {
                id: "2to3",
                x1: 200,
                y1: 200,
                x2: 100,
                y2: 400
            },
            {
                id: "1to3",
                x1: 100,
                y1: 400,
                x2: 50,
                y2: 50
            },
            {
                id: "3to4",
                x1: 100,
                y1: 400,
                x2: 400,
                y2: 400
            },
            {
                id: "2to5",
                x1: 200,
                y1: 200,
                x2: 400,
                y2: 100
            },
            {
                id: "4to5",
                x1: 400,
                y1: 400,
                x2: 400,
                y2: 100
            }
        ],
        network:[[0, 1, 1, 0, 0, 0], [1, 0, 1, 0, 1, 0], [1, 1, 0, 1, 0, 0], [0, 0, 1, 0, 1, 0], [0, 1, 0, 1, 0, 0], [0, 0, 0, 0, 0, 0]]
    },
    {
        nodes:[
            {
                id: "n1",
                textId: "t1",
                cx: 200,
                cy: 50,
                text: 1
            },
            {
                id: "n2",
                textId: "t2",
                cx: 50,
                cy: 150,
                text: 2
            },
            {
                id: "n3",
                textId: "t3",
                cx: 400,
                cy: 150,
                text: 3
            },
            {
                id: "n4",
                textId: "t4",
                cx: 200,
                cy: 250,
                text: 4
            },
            {
                id: "n5",
                textId: "t5",
                cx: 50,
                cy: 350,
                text: 5
            },
            {
                id: "n6",
                textId: "t6",
                cx: 400,
                cy: 350,
                text: 6
            }
        ],
        edges:[
            {
                id: "1to2",
                x1: 200,
                y1: 50,
                x2: 50,
                y2: 150
            },
            {
                id: "1to3",
                x1: 200,
                y1: 50,
                x2: 400,
                y2: 150
            },
            {
                id: "2to4",
                x1: 50,
                y1: 150,
                x2: 200,
                y2: 250
            },
            {
                id: "3to4",
                x1: 400,
                y1: 150,
                x2: 200,
                y2: 250
            },
            {
                id: "4to5",
                x1: 200,
                y1: 250,
                x2: 50,
                y2: 350
            },
            {
                id: "4to6",
                x1: 200,
                y1: 250,
                x2: 400,
                y2: 350
            },
            {
                id: "5to6",
                x1: 50,
                y1: 350,
                x2: 400,
                y2: 350
            }
        ],
        network:[[0,1,1,0,0,0], [1,0,0,1,0,0], [1,0,0,1,0,0], [0,1,1,0,1,1], [0,0,0,1,0,1], [0,0,0,1,1,0]]
    },
    {
        nodes:[
            {
                id: "n1",
                textId: "t1",
                cx: 150,
                cy: 150,
                text: 1
            },
            {
                id: "n2",
                textId: "t2",
                cx: 150,
                cy: 50,
                text: 2
            },
            {
                id: "n3",
                textId: "t3",
                cx: 50,
                cy: 50,
                text: 3
            },
            {
                id: "n4",
                textId: "t4",
                cx: 250,
                cy: 50,
                text: 4
            },
            {
                id: "n5",
                textId: "t5",
                cx: 150,
                cy: 250,
                text: 5
            },
            {
                id: "n6",
                textId: "t6",
                cx: 50,
                cy: 350,
                text: 6
            },
            {
                id: "n7",
                textId: "t7",
                cx: 250,
                cy: 350,
                text: 7
            }
        ],
        edges:[
            {
                id: "1to2",
                x1: 150,
                y1: 150,
                x2: 150,
                y2: 50
            },
            {
                id: "1to3",
                x1: 150,
                y1: 150,
                x2: 50,
                y2: 50
            },
            {
                id: "1to4",
                x1: 150,
                y1: 150,
                x2: 250,
                y2: 50
            },
            {
                id: "1to5",
                x1: 150,
                y1: 150,
                x2: 150,
                y2: 250
            },
            {
                id: "5to6",
                x1: 150,
                y1: 250,
                x2: 50,
                y2: 350
            },
            {
                id: "5to7",
                x1: 150,
                y1: 250,
                x2: 250,
                y2: 350
            }
        ],
        network:[[0,1,1,1,1,0,0], [1,0,0,0,0,0,0], [1,0,0,0,0,0,0], [1,0,0,0,0,0,0], [1,0,0,0,0,1,1], [0,0,0,0,1,0,0], [0,0,0,0,1,0,0]]
    }
]